"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BaseContext", {
  enumerable: true,
  get: function () {
    return _GlobalContext.BaseContext;
  }
});
Object.defineProperty(exports, "BaseContextProvider", {
  enumerable: true,
  get: function () {
    return _GlobalContext.BaseContextProvider;
  }
});
Object.defineProperty(exports, "BrowserRouter", {
  enumerable: true,
  get: function () {
    return _reactRouterDom.BrowserRouter;
  }
});
Object.defineProperty(exports, "ComponentStatus", {
  enumerable: true,
  get: function () {
    return _ComponentsStatus.ComponentStatus;
  }
});
Object.defineProperty(exports, "DmsAccessDenied", {
  enumerable: true,
  get: function () {
    return _DmsAccessDenied.DmsAccessDenied;
  }
});
Object.defineProperty(exports, "DmsAlarmIcon", {
  enumerable: true,
  get: function () {
    return _DmsAlarmIcon.DmsAlarmIcon;
  }
});
Object.defineProperty(exports, "DmsAlertDanger", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertDanger;
  }
});
Object.defineProperty(exports, "DmsAlertDark", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertDark;
  }
});
Object.defineProperty(exports, "DmsAlertInfo", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertInfo;
  }
});
Object.defineProperty(exports, "DmsAlertLight", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertLight;
  }
});
Object.defineProperty(exports, "DmsAlertPrimary", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertPrimary;
  }
});
Object.defineProperty(exports, "DmsAlertSecondary", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertSecondary;
  }
});
Object.defineProperty(exports, "DmsAlertSuccess", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertSuccess;
  }
});
Object.defineProperty(exports, "DmsAlertWarning", {
  enumerable: true,
  get: function () {
    return _DmsAlert.DmsAlertWarning;
  }
});
Object.defineProperty(exports, "DmsAltBox", {
  enumerable: true,
  get: function () {
    return _DmsAltBox.DmsAltBox;
  }
});
Object.defineProperty(exports, "DmsAltBoxInfo", {
  enumerable: true,
  get: function () {
    return _DmsAltBoxInfo.DmsAltBoxInfo;
  }
});
Object.defineProperty(exports, "DmsBarChart", {
  enumerable: true,
  get: function () {
    return _DmsChart.DmsBarChart;
  }
});
Object.defineProperty(exports, "DmsBarMenuButton", {
  enumerable: true,
  get: function () {
    return _DmsBarMenuButton.DmsBarMenuButton;
  }
});
Object.defineProperty(exports, "DmsBreadcrumbNavigate", {
  enumerable: true,
  get: function () {
    return _DmsBreadcrumbNavigate.DmsBreadcrumbNavigate;
  }
});
Object.defineProperty(exports, "DmsButton", {
  enumerable: true,
  get: function () {
    return _DmsButton.DmsButton;
  }
});
Object.defineProperty(exports, "DmsButtonGroup", {
  enumerable: true,
  get: function () {
    return _DmsButtonGroup.DmsButtonGroup;
  }
});
Object.defineProperty(exports, "DmsButtonNavigate", {
  enumerable: true,
  get: function () {
    return _DmsButtonNavigate.DmsButtonNavigate;
  }
});
Object.defineProperty(exports, "DmsButtonParentNavigate", {
  enumerable: true,
  get: function () {
    return _DmsButtonParentNavigate.DmsButtonParentNavigate;
  }
});
Object.defineProperty(exports, "DmsButtonV2", {
  enumerable: true,
  get: function () {
    return _DmsButtonV.DmsButtonV2;
  }
});
Object.defineProperty(exports, "DmsCalendar", {
  enumerable: true,
  get: function () {
    return _DmsCalendar.DmsCalendar;
  }
});
Object.defineProperty(exports, "DmsCarousel", {
  enumerable: true,
  get: function () {
    return _DmsCarousel.DmsCarousel;
  }
});
Object.defineProperty(exports, "DmsCheckBox", {
  enumerable: true,
  get: function () {
    return _DmsCheckBox.DmsCheckBox;
  }
});
Object.defineProperty(exports, "DmsComponents", {
  enumerable: true,
  get: function () {
    return _DmsComponents.DmsComponents;
  }
});
Object.defineProperty(exports, "DmsCustomChart", {
  enumerable: true,
  get: function () {
    return _DmsChart.DmsCustomChart;
  }
});
Object.defineProperty(exports, "DmsDataGrid", {
  enumerable: true,
  get: function () {
    return _DmsDataGrid.DmsDataGrid;
  }
});
Object.defineProperty(exports, "DmsDateRangePicker", {
  enumerable: true,
  get: function () {
    return _DmsDateRangePicker.DmsDateRangePicker;
  }
});
Object.defineProperty(exports, "DmsDateTime", {
  enumerable: true,
  get: function () {
    return _DmsDateTime.DmsDateTime;
  }
});
Object.defineProperty(exports, "DmsDateTimePicker", {
  enumerable: true,
  get: function () {
    return _DmsDateTimePicker.DmsDateTimePicker;
  }
});
Object.defineProperty(exports, "DmsDateTimeRangePicker", {
  enumerable: true,
  get: function () {
    return _DmsDateTimeRangePicker.DmsDateTimeRangePicker;
  }
});
Object.defineProperty(exports, "DmsDoubleBlind", {
  enumerable: true,
  get: function () {
    return _DmsDoubleBlind.DmsDoubleBlind;
  }
});
Object.defineProperty(exports, "DmsDragAndDropGrid", {
  enumerable: true,
  get: function () {
    return _DmsDragAndDropGrid.DmsDragAndDropGrid;
  }
});
Object.defineProperty(exports, "DmsDragAndDropTags", {
  enumerable: true,
  get: function () {
    return _DmsDragAndDropTags.DmsDragAndDropTags;
  }
});
Object.defineProperty(exports, "DmsDropdown", {
  enumerable: true,
  get: function () {
    return _DmsDropdown.DmsDropdown;
  }
});
Object.defineProperty(exports, "DmsExport", {
  enumerable: true,
  get: function () {
    return _DmsExport.DmsExport;
  }
});
Object.defineProperty(exports, "DmsFlexContainer", {
  enumerable: true,
  get: function () {
    return _DmsFlexContainer.DmsFlexContainer;
  }
});
Object.defineProperty(exports, "DmsFooter", {
  enumerable: true,
  get: function () {
    return _DmsFooter.DmsFooter;
  }
});
Object.defineProperty(exports, "DmsForm", {
  enumerable: true,
  get: function () {
    return _DmsForm.DmsForm;
  }
});
Object.defineProperty(exports, "DmsFullScreenButton", {
  enumerable: true,
  get: function () {
    return _DmsFullScreenButton.DmsFullScreenButton;
  }
});
Object.defineProperty(exports, "DmsIFrame", {
  enumerable: true,
  get: function () {
    return _DmsIFrame.DmsIFrame;
  }
});
Object.defineProperty(exports, "DmsIntlManager", {
  enumerable: true,
  get: function () {
    return _DmsIntlManager.DmsIntlManager;
  }
});
Object.defineProperty(exports, "DmsKeyboardButton", {
  enumerable: true,
  get: function () {
    return _DmsKeyboardButton.DmsKeyboardButton;
  }
});
Object.defineProperty(exports, "DmsLdapAuthenticatorSettings", {
  enumerable: true,
  get: function () {
    return _DmsLdapAuthenticatorSettings.DmsLdapAuthenticatorSettings;
  }
});
Object.defineProperty(exports, "DmsLineChart", {
  enumerable: true,
  get: function () {
    return _DmsChart.DmsLineChart;
  }
});
Object.defineProperty(exports, "DmsLoading", {
  enumerable: true,
  get: function () {
    return _DmsLoading.DmsLoading;
  }
});
Object.defineProperty(exports, "DmsLog", {
  enumerable: true,
  get: function () {
    return _DmsLog.DmsLog;
  }
});
Object.defineProperty(exports, "DmsLogViewer", {
  enumerable: true,
  get: function () {
    return _DmsLogViewer.DmsLogViewer;
  }
});
Object.defineProperty(exports, "DmsLogViewerTable", {
  enumerable: true,
  get: function () {
    return _DmsLogViewerTable.DmsLogViewerTable;
  }
});
Object.defineProperty(exports, "DmsLogin", {
  enumerable: true,
  get: function () {
    return _DmsLogin.DmsLogin;
  }
});
Object.defineProperty(exports, "DmsLoginSettings", {
  enumerable: true,
  get: function () {
    return _DmsLoginSettings.DmsLoginSettings;
  }
});
Object.defineProperty(exports, "DmsLogoIcon", {
  enumerable: true,
  get: function () {
    return _DmsLogoIcon.DmsLogoIcon;
  }
});
Object.defineProperty(exports, "DmsLogout", {
  enumerable: true,
  get: function () {
    return _DmsLogout.DmsLogout;
  }
});
Object.defineProperty(exports, "DmsLogsSettings", {
  enumerable: true,
  get: function () {
    return _DmsLogsSettings.DmsLogsSettings;
  }
});
Object.defineProperty(exports, "DmsLogsTable", {
  enumerable: true,
  get: function () {
    return _DmsLogsTable.DmsLogsTable;
  }
});
Object.defineProperty(exports, "DmsMainHeader", {
  enumerable: true,
  get: function () {
    return _DmsMainHeader.DmsMainHeader;
  }
});
Object.defineProperty(exports, "DmsMainSidebar", {
  enumerable: true,
  get: function () {
    return _DmsMainSidebar.DmsMainSidebar;
  }
});
Object.defineProperty(exports, "DmsMainSidebarMenu", {
  enumerable: true,
  get: function () {
    return _DmsMainSidebarMenu.DmsMainSidebarMenu;
  }
});
Object.defineProperty(exports, "DmsMainSidebarOption", {
  enumerable: true,
  get: function () {
    return _DmsMainSidebarOption.DmsMainSidebarOption;
  }
});
Object.defineProperty(exports, "DmsMap", {
  enumerable: true,
  get: function () {
    return _DmsMap.DmsMap;
  }
});
Object.defineProperty(exports, "DmsMenuNavegation", {
  enumerable: true,
  get: function () {
    return _DmsMenuNavigate.DmsMenuNavegation;
  }
});
Object.defineProperty(exports, "DmsModal", {
  enumerable: true,
  get: function () {
    return _DmsModal.DmsModal;
  }
});
Object.defineProperty(exports, "DmsNotificationsMenuHeader", {
  enumerable: true,
  get: function () {
    return _DmsNotificationsMenuHeader.DmsNotificationsMenuHeader;
  }
});
Object.defineProperty(exports, "DmsPage", {
  enumerable: true,
  get: function () {
    return _DmsPage.DmsPage;
  }
});
Object.defineProperty(exports, "DmsPageBatch", {
  enumerable: true,
  get: function () {
    return _DmsBatch.DmsPageBatch;
  }
});
Object.defineProperty(exports, "DmsPageComponentImport", {
  enumerable: true,
  get: function () {
    return _DmsPageComponentImport.DmsPageComponentImport;
  }
});
Object.defineProperty(exports, "DmsPageComponentTypeImport", {
  enumerable: true,
  get: function () {
    return _DmsPageComponentTypeImport.DmsPageComponentTypeImport;
  }
});
Object.defineProperty(exports, "DmsPageComponents", {
  enumerable: true,
  get: function () {
    return _DmsPageComponents.DmsPageComponents;
  }
});
Object.defineProperty(exports, "DmsPageFileImporter", {
  enumerable: true,
  get: function () {
    return _DmsPageFileImporter.DmsPageFileImporter;
  }
});
Object.defineProperty(exports, "DmsPageFileType", {
  enumerable: true,
  get: function () {
    return _DmsPageFileType.DmsPageFileType;
  }
});
Object.defineProperty(exports, "DmsPageFingerPrinter", {
  enumerable: true,
  get: function () {
    return _DmsPageFingerPrinter.DmsPageFingerPrinter;
  }
});
Object.defineProperty(exports, "DmsPageLDAPAuthenticatorSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageLDAPAuthenticatorSettings.DmsPageLDAPAuthenticatorSettings;
  }
});
Object.defineProperty(exports, "DmsPageLoginSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageLoginSettings.DmsPageLoginSettings;
  }
});
Object.defineProperty(exports, "DmsPageLogs", {
  enumerable: true,
  get: function () {
    return _DmsPageLogs.DmsPageLogs;
  }
});
Object.defineProperty(exports, "DmsPageLogsReport", {
  enumerable: true,
  get: function () {
    return _DmsPageLogsReport.DmsPageLogsReport;
  }
});
Object.defineProperty(exports, "DmsPageLogsSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageLogsSettings.DmsPageLogsSettings;
  }
});
Object.defineProperty(exports, "DmsPageNotFound", {
  enumerable: true,
  get: function () {
    return _DmsPageNotFound.DmsPageNotFound;
  }
});
Object.defineProperty(exports, "DmsPagePartCompositionTable", {
  enumerable: true,
  get: function () {
    return _DmsPagePartCompositionTable.DmsPagePartCompositionTable;
  }
});
Object.defineProperty(exports, "DmsPagePartTable", {
  enumerable: true,
  get: function () {
    return _DmsPagePartTable.DmsPagePartTable;
  }
});
Object.defineProperty(exports, "DmsPageProduct", {
  enumerable: true,
  get: function () {
    return _DmsPageProduct.DmsPageProduct;
  }
});
Object.defineProperty(exports, "DmsPageProductImport", {
  enumerable: true,
  get: function () {
    return _DmsPageProductImport.DmsPageProductImport;
  }
});
Object.defineProperty(exports, "DmsPageProductionOrder", {
  enumerable: true,
  get: function () {
    return _DmsProductionOrder.DmsPageProductionOrder;
  }
});
Object.defineProperty(exports, "DmsPageRecipe", {
  enumerable: true,
  get: function () {
    return _DmsPageRecipe.DmsPageRecipe;
  }
});
Object.defineProperty(exports, "DmsPageRegisterRecipe", {
  enumerable: true,
  get: function () {
    return _DmsPageRecipe.DmsPageRegisterRecipe;
  }
});
Object.defineProperty(exports, "DmsPageRemoteAuthenticatorSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageRemoteAuthenticatorSettings.DmsPageRemoteAuthenticatorSettings;
  }
});
Object.defineProperty(exports, "DmsPageRole", {
  enumerable: true,
  get: function () {
    return _DmsPageRole.DmsPageRole;
  }
});
Object.defineProperty(exports, "DmsPageRouteList", {
  enumerable: true,
  get: function () {
    return _DmsPageRouteList.DmsPageRouteList;
  }
});
Object.defineProperty(exports, "DmsPageSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageSystemSettings.DmsPageSystemSettings;
  }
});
Object.defineProperty(exports, "DmsPageUSBComponents", {
  enumerable: true,
  get: function () {
    return _DmsPageUSBComponents.DmsPageUSBComponents;
  }
});
Object.defineProperty(exports, "DmsPageUploadFileSettings", {
  enumerable: true,
  get: function () {
    return _DmsPageUploadFileSettings.DmsPageUploadFileSettings;
  }
});
Object.defineProperty(exports, "DmsPageUser", {
  enumerable: true,
  get: function () {
    return _DmsPageUser.DmsPageUser;
  }
});
Object.defineProperty(exports, "DmsPageUserLanguage", {
  enumerable: true,
  get: function () {
    return _DmsPageUserLanguage.DmsPageUserLanguage;
  }
});
Object.defineProperty(exports, "DmsPartCompositionTable", {
  enumerable: true,
  get: function () {
    return _DmsPartCompositionTable.DmsPartCompositionTable;
  }
});
Object.defineProperty(exports, "DmsPartTable", {
  enumerable: true,
  get: function () {
    return _DmsPartTable.DmsPartTable;
  }
});
Object.defineProperty(exports, "DmsPasswordValidation", {
  enumerable: true,
  get: function () {
    return _DmsPasswordValidation.DmsPasswordValidation;
  }
});
Object.defineProperty(exports, "DmsPermissions", {
  enumerable: true,
  get: function () {
    return _DmsPermissions.DmsPermissions;
  }
});
Object.defineProperty(exports, "DmsPieChart", {
  enumerable: true,
  get: function () {
    return _DmsChart.DmsPieChart;
  }
});
Object.defineProperty(exports, "DmsProductionOrderStatusRectangle", {
  enumerable: true,
  get: function () {
    return _DmsProductionOrderStatusRectangle.DmsProductionOrderStatusRectangle;
  }
});
Object.defineProperty(exports, "DmsReactQueryProvider", {
  enumerable: true,
  get: function () {
    return _DmsReactQueryProvider.DmsReactQueryProvider;
  }
});
Object.defineProperty(exports, "DmsRecipeParameterTable", {
  enumerable: true,
  get: function () {
    return _DmsRecipeParameterTable.DmsRecipeParameterTable;
  }
});
Object.defineProperty(exports, "DmsRecipeParameterValueTable", {
  enumerable: true,
  get: function () {
    return _DmsRecipeParameterValueTable.DmsRecipeParameterValueTable;
  }
});
Object.defineProperty(exports, "DmsRemoteAuthenticatorSettings", {
  enumerable: true,
  get: function () {
    return _DmsRemoteAuthenticatorSettings.DmsRemoteAuthenticatorSettings;
  }
});
Object.defineProperty(exports, "DmsRouteList", {
  enumerable: true,
  get: function () {
    return _DmsRouteList.DmsRouteList;
  }
});
Object.defineProperty(exports, "DmsRouter", {
  enumerable: true,
  get: function () {
    return _DmsRouter.DmsRouter;
  }
});
Object.defineProperty(exports, "DmsSearchMap", {
  enumerable: true,
  get: function () {
    return _DmsSearchMap.DmsSearchMap;
  }
});
Object.defineProperty(exports, "DmsSelect", {
  enumerable: true,
  get: function () {
    return _DmsSelect.DmsSelect;
  }
});
Object.defineProperty(exports, "DmsSimpleTreeView", {
  enumerable: true,
  get: function () {
    return _DmsSimpleTreeView.DmsSimpleTreeView;
  }
});
Object.defineProperty(exports, "DmsSpinner", {
  enumerable: true,
  get: function () {
    return _DmsSpinner.DmsSpinner;
  }
});
Object.defineProperty(exports, "DmsSwitch", {
  enumerable: true,
  get: function () {
    return _DmsSwitch.DmsSwitch;
  }
});
Object.defineProperty(exports, "DmsSystemMonitor", {
  enumerable: true,
  get: function () {
    return _DmsSystemMonitor.DmsSystemMonitor;
  }
});
Object.defineProperty(exports, "DmsSystemSettings", {
  enumerable: true,
  get: function () {
    return _DmsSystemSettings.DmsSystemSettings;
  }
});
Object.defineProperty(exports, "DmsSystemSettingsTabber", {
  enumerable: true,
  get: function () {
    return _DmsSystemSettingsTabber.DmsSystemSettingsTabber;
  }
});
Object.defineProperty(exports, "DmsTabber", {
  enumerable: true,
  get: function () {
    return _DmsTabber.DmsTabber;
  }
});
Object.defineProperty(exports, "DmsTable", {
  enumerable: true,
  get: function () {
    return _DmsTable.DmsTable;
  }
});
Object.defineProperty(exports, "DmsTableButton", {
  enumerable: true,
  get: function () {
    return _DmsTableButton.DmsTableButton;
  }
});
Object.defineProperty(exports, "DmsTableCreateButton", {
  enumerable: true,
  get: function () {
    return _DmsTableCreateButton.DmsTableCreateButton;
  }
});
Object.defineProperty(exports, "DmsTableDeleteButton", {
  enumerable: true,
  get: function () {
    return _DmsTableDeleteButton.DmsTableDeleteButton;
  }
});
Object.defineProperty(exports, "DmsTableEditButton", {
  enumerable: true,
  get: function () {
    return _DmsTableEditButton.DmsTableEditButton;
  }
});
Object.defineProperty(exports, "DmsTagInput", {
  enumerable: true,
  get: function () {
    return _DmsTagInput.DmsTagInput;
  }
});
Object.defineProperty(exports, "DmsTextField", {
  enumerable: true,
  get: function () {
    return _DmsTextField.DmsTextField;
  }
});
Object.defineProperty(exports, "DmsTextFieldCnpj", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldCnpj.DmsTextFieldCnpj;
  }
});
Object.defineProperty(exports, "DmsTextFieldEmail", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldEmail.DmsTextFieldEmail;
  }
});
Object.defineProperty(exports, "DmsTextFieldIpv4", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldIpv.DmsTextFieldIpv4;
  }
});
Object.defineProperty(exports, "DmsTextFieldMasked", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldMasked.DmsTextFieldMasked;
  }
});
Object.defineProperty(exports, "DmsTextFieldPassword", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldPassword.DmsTextFieldPassword;
  }
});
Object.defineProperty(exports, "DmsTextFieldPhone", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldPhone.DmsTextFieldPhone;
  }
});
Object.defineProperty(exports, "DmsTextFieldPort", {
  enumerable: true,
  get: function () {
    return _DmsTextFieldPort.DmsTextFieldPort;
  }
});
Object.defineProperty(exports, "DmsToolbarNavigate", {
  enumerable: true,
  get: function () {
    return _DmsToolbarNavigate.DmsToolbarNavigate;
  }
});
Object.defineProperty(exports, "DmsUSBComponents", {
  enumerable: true,
  get: function () {
    return _DmsUSBComponents.DmsUSBComponents;
  }
});
Object.defineProperty(exports, "DmsUnderDevelopment", {
  enumerable: true,
  get: function () {
    return _DmsUnderDevelopment.DmsUnderDevelopment;
  }
});
Object.defineProperty(exports, "DmsUploadFile", {
  enumerable: true,
  get: function () {
    return _DmsUploadFile.DmsUploadFile;
  }
});
Object.defineProperty(exports, "DmsUploadFileSettings", {
  enumerable: true,
  get: function () {
    return _DmsUploadFileSettings.DmsUploadFileSettings;
  }
});
Object.defineProperty(exports, "DmsUserInformation", {
  enumerable: true,
  get: function () {
    return _DmsUserInformation.DmsUserInformation;
  }
});
Object.defineProperty(exports, "DmsUserTable", {
  enumerable: true,
  get: function () {
    return _DmsUserTable.DmsUserTable;
  }
});
Object.defineProperty(exports, "DmsVirtualKeyboard", {
  enumerable: true,
  get: function () {
    return _DmsVirtualKeyboard.DmsVirtualKeyboard;
  }
});
Object.defineProperty(exports, "DmsWarningIcon", {
  enumerable: true,
  get: function () {
    return _DmsWarningIcon.DmsWarningIcon;
  }
});
Object.defineProperty(exports, "HTTP_STATUS", {
  enumerable: true,
  get: function () {
    return _HttpStatus.HTTP_STATUS;
  }
});
Object.defineProperty(exports, "IMAGES", {
  enumerable: true,
  get: function () {
    return _Images.IMAGES;
  }
});
Object.defineProperty(exports, "InactivityContextProvider", {
  enumerable: true,
  get: function () {
    return _InactivityContext.InactivityContextProvider;
  }
});
Object.defineProperty(exports, "LOCALES", {
  enumerable: true,
  get: function () {
    return _Locales.LOCALES;
  }
});
Object.defineProperty(exports, "LOCALES_FLAG", {
  enumerable: true,
  get: function () {
    return _Locales.LOCALES_FLAG;
  }
});
Object.defineProperty(exports, "LanguageBaseContext", {
  enumerable: true,
  get: function () {
    return _LanguageContext.LanguageBaseContext;
  }
});
Object.defineProperty(exports, "LanguageBaseContextProvider", {
  enumerable: true,
  get: function () {
    return _LanguageContext.LanguageBaseContextProvider;
  }
});
Object.defineProperty(exports, "LanguageEnum", {
  enumerable: true,
  get: function () {
    return _LanguageEnum.Languages;
  }
});
Object.defineProperty(exports, "LocalStorageVariables", {
  enumerable: true,
  get: function () {
    return _LocalStorage.LocalStorageVariables;
  }
});
Object.defineProperty(exports, "LogLevel", {
  enumerable: true,
  get: function () {
    return _Log.LogLevel;
  }
});
Object.defineProperty(exports, "LogType", {
  enumerable: true,
  get: function () {
    return _Log.LogType;
  }
});
Object.defineProperty(exports, "LogoffProvider", {
  enumerable: true,
  get: function () {
    return _LogOffContext.LogoffProvider;
  }
});
Object.defineProperty(exports, "Notifications", {
  enumerable: true,
  get: function () {
    return _notifications.Notifications;
  }
});
Object.defineProperty(exports, "PasswordRegexDescription", {
  enumerable: true,
  get: function () {
    return _PasswordRegexDescription.PasswordRegexDescription;
  }
});
Object.defineProperty(exports, "PasswordRules", {
  enumerable: true,
  get: function () {
    return _PasswordRegexDescription.PasswordRules;
  }
});
Object.defineProperty(exports, "PasswordRulesDescription", {
  enumerable: true,
  get: function () {
    return _PasswordRegexDescription.PasswordRulesDescription;
  }
});
Object.defineProperty(exports, "Permissions", {
  enumerable: true,
  get: function () {
    return _Permissions.Permissions;
  }
});
Object.defineProperty(exports, "ProductionOrderStatus", {
  enumerable: true,
  get: function () {
    return _ProductionOrderStatus.ProductionOrderStatus;
  }
});
Object.defineProperty(exports, "ROUTES", {
  enumerable: true,
  get: function () {
    return _NamedRoutes.ROUTES;
  }
});
Object.defineProperty(exports, "SSE", {
  enumerable: true,
  get: function () {
    return _sse.SSE;
  }
});
Object.defineProperty(exports, "ToastContainer", {
  enumerable: true,
  get: function () {
    return _reactToastify.ToastContainer;
  }
});
Object.defineProperty(exports, "blueMarkerIcon", {
  enumerable: true,
  get: function () {
    return _Position.blueMarkerIcon;
  }
});
Object.defineProperty(exports, "countryCode", {
  enumerable: true,
  get: function () {
    return _Position.countryCode;
  }
});
Object.defineProperty(exports, "createRoot", {
  enumerable: true,
  get: function () {
    return _client.createRoot;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "defaultPosition", {
  enumerable: true,
  get: function () {
    return _Position.defaultPosition;
  }
});
Object.defineProperty(exports, "downloadUrl", {
  enumerable: true,
  get: function () {
    return _DmsFetch.downloadUrl;
  }
});
Object.defineProperty(exports, "fetchData", {
  enumerable: true,
  get: function () {
    return _DmsFetch.fetchData;
  }
});
Object.defineProperty(exports, "fetchDataIgnoringTokenUsage", {
  enumerable: true,
  get: function () {
    return _DmsFetch.fetchDataIgnoringTokenUsage;
  }
});
Object.defineProperty(exports, "fetchUrl", {
  enumerable: true,
  get: function () {
    return _DmsFetch.fetchUrl;
  }
});
Object.defineProperty(exports, "generate_random_id", {
  enumerable: true,
  get: function () {
    return _pollux_dms.generate_random_id;
  }
});
Object.defineProperty(exports, "getRefreshToken", {
  enumerable: true,
  get: function () {
    return _DmsTokenHook.getRefreshToken;
  }
});
Object.defineProperty(exports, "getToken", {
  enumerable: true,
  get: function () {
    return _DmsTokenHook.getToken;
  }
});
Object.defineProperty(exports, "havePermissions", {
  enumerable: true,
  get: function () {
    return _DmsPermissions.havePermissions;
  }
});
Object.defineProperty(exports, "intl", {
  enumerable: true,
  get: function () {
    return _reactIntlUniversal.default;
  }
});
Object.defineProperty(exports, "log", {
  enumerable: true,
  get: function () {
    return _log.log;
  }
});
Object.defineProperty(exports, "loginUser", {
  enumerable: true,
  get: function () {
    return _DmsLogin.loginUser;
  }
});
exports.setBuildConfiguration = void 0;
Object.defineProperty(exports, "setToken", {
  enumerable: true,
  get: function () {
    return _DmsTokenHook.setToken;
  }
});
Object.defineProperty(exports, "tileLayer", {
  enumerable: true,
  get: function () {
    return _Position.tileLayer;
  }
});
Object.defineProperty(exports, "useDmsInactivityLogout", {
  enumerable: true,
  get: function () {
    return _useDmsInactivityLogout.useDmsInactivityLogout;
  }
});
Object.defineProperty(exports, "useDmsLogoffTabs", {
  enumerable: true,
  get: function () {
    return _useDmsLogoffTabs.useDmsLogoffTabs;
  }
});
Object.defineProperty(exports, "useDmsPasswordExpiration", {
  enumerable: true,
  get: function () {
    return _useDmsPasswordExpiration.useDmsPasswordExpiration;
  }
});
Object.defineProperty(exports, "useDmsTokenRefresh", {
  enumerable: true,
  get: function () {
    return _useDmsTokenRefresh.useDmsTokenRefresh;
  }
});
Object.defineProperty(exports, "useGet", {
  enumerable: true,
  get: function () {
    return _useGet.useGet;
  }
});
Object.defineProperty(exports, "useInactivityContext", {
  enumerable: true,
  get: function () {
    return _InactivityContext.useInactivityContext;
  }
});
Object.defineProperty(exports, "useLogoffContext", {
  enumerable: true,
  get: function () {
    return _LogOffContext.useLogoffContext;
  }
});
Object.defineProperty(exports, "useMutate", {
  enumerable: true,
  get: function () {
    return _useMutate.useMutate;
  }
});
Object.defineProperty(exports, "useSidebarToggle", {
  enumerable: true,
  get: function () {
    return _useSidebarToggle.useSidebarToggle;
  }
});
Object.defineProperty(exports, "useToken", {
  enumerable: true,
  get: function () {
    return _DmsTokenHook.useToken;
  }
});
require("bootstrap/dist/css/bootstrap.min.css");
require("react-toastify/dist/ReactToastify.css");
require("./index.css");
require("@fontsource/roboto/300.css");
require("@fontsource/roboto/400.css");
require("@fontsource/roboto/500.css");
require("@fontsource/roboto/700.css");
var _sse = require("./service/server/sse.js");
var _notifications = require("./service/notifications/notifications.js");
var _theme = _interopRequireDefault(require("./config/theme"));
var _DmsIntlManager = require("./service/Intl/DmsIntlManager.js");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _GlobalContext = require("./context/GlobalContext.js");
var _LanguageContext = require("./context/LanguageContext.js");
var _InactivityContext = require("./context/InactivityContext.js");
var _LogOffContext = require("./context/LogOffContext.js");
var _DmsFooter = require("./components/DmsAdmin/DmsFooter");
var _DmsMainHeader = require("./components/DmsMainHeader/DmsMainHeader");
var _DmsMainSidebar = require("./components/DmsAdmin/Sidebar/DmsMainSidebar");
var _DmsMainSidebarMenu = require("./components/DmsAdmin/Sidebar/DmsMainSidebarMenu");
var _DmsMainSidebarOption = require("./components/DmsAdmin/Sidebar/DmsMainSidebarOption");
var _useGet = require("./Hooks/useGet.js");
var _useMutate = require("./Hooks/useMutate.js");
var _useDmsInactivityLogout = require("./Hooks/useDmsInactivityLogout.js");
var _useDmsPasswordExpiration = require("./Hooks/useDmsPasswordExpiration.js");
var _useDmsTokenRefresh = require("./Hooks/useDmsTokenRefresh.js");
var _useSidebarToggle = require("./components/DmsAdmin/Sidebar/useSidebarToggle");
var _DmsAlarmIcon = require("./components/DmsLogViewer/DmsAlarmIcon.js");
var _DmsAlert = require("./components/DmsAlert/DmsAlert.js");
var _DmsAltBox = require("./components/DmsAltBox/DmsAltBox.js");
var _DmsAltBoxInfo = require("./components/DmsAltBoxInfo/DmsAltBoxInfo.js");
var _DmsChart = require("./components/DmsChart/DmsChart.js");
var _DmsBarMenuButton = require("./components/DmsBarMenuButton/DmsBarMenuButton.js");
var _DmsBreadcrumbNavigate = require("./components/DmsBreadcrumbNavigate/DmsBreadcrumbNavigate.js");
var _DmsButton = require("./components/DmsButton/DmsButton.js");
var _DmsButtonGroup = require("./components/DmsButtonGroup/DmsButtonGroup.js");
var _DmsButtonNavigate = require("./components/DmsButtonNavigate/DmsButtonNavigate.js");
var _DmsButtonParentNavigate = require("./components/DmsButtonParentNavigate/DmsButtonParentNavigate.js");
var _DmsButtonV = require("./components/v2/DmsButton/DmsButtonV2.js");
var _DmsCarousel = require("./components/DmsCarousel/DmsCarousel.js");
var _DmsCalendar = require("./components/DmsCalendar/DmsCalendar.js");
var _DmsCheckBox = require("./components/DmsCheckBox/DmsCheckBox.js");
var _DmsComponents = require("./components/DmsComponent/DmsComponents.js");
var _DmsDataGrid = require("./components/DmsDataGrid/DmsDataGrid");
var _DmsDateTimePicker = require("./components/DmsDateTimePicker/DmsDateTimePicker.js");
var _DmsDateTimeRangePicker = require("./components/DmsDateTimeRangePicker/DmsDateTimeRangePicker.js");
var _DmsDateRangePicker = require("./components/DmsDateRangePicker/DmsDateRangePicker.js");
var _DmsDateTime = require("./components/DmsDateTime/DmsDateTime.js");
var _DmsDoubleBlind = require("./components/DmsDoubleBlind/DmsDoubleBlind.js");
var _DmsDragAndDropGrid = require("./components/DmsDragAndDropGrid/DmsDragAndDropGrid");
var _DmsDragAndDropTags = require("./components/DmsDragAndDropTags/DmsDragAndDropTags");
var _DmsDropdown = require("./components/DmsDropdown/DmsDropdown.js");
var _DmsExport = require("./components/DmsExport/DmsExport.js");
var _DmsFlexContainer = require("./components/DmsFlexContainer/DmsFlexContainer.js");
var _DmsForm = require("./components/DmsForm/DmsForm.js");
var _DmsFullScreenButton = require("./components/DmsFullScreenButton/DmsFullScreenButton.js");
var _DmsIFrame = require("./components/DmsIFrame/DmsIFrame.js");
var _DmsKeyboardButton = require("./components/DmsKeyboardButton/DmsKeyboardButton.js");
var _DmsVirtualKeyboard = require("./components/DmsVirtualKeyboard/DmsVirtualKeyboard.js");
var _DmsLdapAuthenticatorSettings = require("./components/DmsAuthenticatorsSettings/DmsLdapAuthenticatorSettings.js");
var _DmsLoading = require("./components/DmsLoading/DmsLoading.js");
var _DmsLog = require("./components/DmsLog/DmsLog.js");
var _DmsLogViewer = require("./components/DmsLogViewer/DmsLogViewer.js");
var _DmsLogViewerTable = require("./components/DmsLogViewer/DmsLogViewerTable.js");
var _DmsLoginSettings = require("./components/DmsLoginSettings/DmsLoginSettings.js");
var _DmsLogoIcon = require("./components/DmsLogoIcon/DmsLogoIcon.js");
var _DmsLogout = require("./components/DmsLogout/DmsLogout.js");
var _DmsLogsTable = require("./components/DmsLogs/DmsLogsTable.js");
var _DmsLogsSettings = require("./components/DmsLogs/DmsLogsSettings.js");
var _DmsMap = require("./components/DmsMap/DmsMap.js");
var _DmsMenuNavigate = require("./components/DmsMenuNavigate/DmsMenuNavigate.js");
var _DmsModal = require("./components/DmsModal/DmsModal");
var _DmsNotificationsMenuHeader = require("./components/DmsNotificationsMenuHeader/DmsNotificationsMenuHeader.js");
var _DmsPage = require("./components/DmsPage/DmsPage.js");
var _DmsPartCompositionTable = require("./components/DmsPartCompositionTable/DmsPartCompositionTable.js");
var _DmsPartTable = require("./components/DmsPartTable/DmsPartTable.js");
var _DmsPasswordValidation = require("./components/DmsPasswordValidation/DmsPasswordValidation.js");
var _DmsPermissions = require("./components/DmsPermissions/DmsPermissions.js");
var _DmsProductionOrderStatusRectangle = require("./components/DmsProductionOrder/DmsProductionOrderStatusRectangle.js");
var _DmsReactQueryProvider = require("./components/DmsReactQueryProvider/DmsReactQueryProvider");
var _DmsRemoteAuthenticatorSettings = require("./components/DmsAuthenticatorsSettings/DmsRemoteAuthenticatorSettings.js");
var _DmsRouteList = require("./components/DmsRouteList/DmsRouteList.js");
var _DmsRouter = require("./components/DmsRouter/DmsRouter.js");
var _DmsSearchMap = require("./components/DmsMap/DmsSearchMap.js");
var _DmsSelect = require("./components/DmsSelect/DmsSelect");
var _DmsSimpleTreeView = require("./components/DmsSimpleTreeView/DmsSimpleTreeView.js");
var _DmsSpinner = require("./components/DmsSpinner/DmsSpinner.js");
var _DmsSwitch = require("./components/DmsSwitch/DmsSwitch.js");
var _DmsSystemSettingsTabber = require("./components/DmsSystemSettingsTabber/DmsSystemSettingsTabber.js");
var _DmsTabber = require("./components/DmsTabber/DmsTabber");
var _DmsTable = require("./components/DmsTable/DmsTable.js");
var _DmsTableButton = require("./components/DmsTableButton/DmsTableButton.js");
var _DmsTableCreateButton = require("./components/DmsTableButton/DmsTableCreateButton.js");
var _DmsTableDeleteButton = require("./components/DmsTableButton/DmsTableDeleteButton.js");
var _DmsTableEditButton = require("./components/DmsTableButton/DmsTableEditButton.js");
var _DmsTagInput = require("./components/DmsTagInput/DmsTagInput.js");
var _DmsTextField = require("./components/DmsTextField/DmsTextField.js");
var _DmsTextFieldCnpj = require("./components/DmsTextField/DmsTextFieldCnpj.js");
var _DmsTextFieldEmail = require("./components/DmsTextField/DmsTextFieldEmail.js");
var _DmsTextFieldIpv = require("./components/DmsTextField/DmsTextFieldIpv4.js");
var _DmsTextFieldMasked = require("./components/DmsTextField/DmsTextFieldMasked.js");
var _DmsTextFieldPassword = require("./components/DmsTextField/DmsTextFieldPassword.js");
var _DmsTextFieldPhone = require("./components/DmsTextField/DmsTextFieldPhone.js");
var _DmsTextFieldPort = require("./components/DmsTextField/DmsTextFieldPort.js");
var _DmsToolbarNavigate = require("./components/DmsToolbarNavigate/DmsToolbarNavigate.js");
var _DmsUploadFile = require("./components/DmsUploadFile/DmsUploadFile.js");
var _DmsUSBComponents = require("./components/DmsUSBComponent/DmsUSBComponents.js");
var _DmsUserInformation = require("./components/DmsUserInformation/DmsUserInformation.js");
var _DmsUserTable = require("./components/DmsUserTable/DmsUserTable.js");
var _DmsWarningIcon = require("./components/DmsLogViewer/DmsWarningIcon.js");
var _DmsRecipeParameterTable = require("./components/DmsRecipeParameter/DmsRecipeParameterTable.js");
var _DmsRecipeParameterValueTable = require("./components/DmsRecipeParameterValue/DmsRecipeParameterValueTable.js");
var _Position = require("./constants/Position");
var _ComponentsStatus = require("./constants/ComponentsStatus.js");
var _HttpStatus = require("./constants/HttpStatus");
var _Locales = require("./constants/Locales");
var _LocalStorage = require("./constants/LocalStorage");
var _Log = require("./constants/Log");
var _Permissions = require("./constants/Permissions");
var _NamedRoutes = require("./constants/NamedRoutes");
var _PasswordRegexDescription = require("./constants/PasswordRegexDescription.js");
var _ProductionOrderStatus = require("./constants/ProductionOrderStatus.js");
var _Images = require("./constants/Images");
var _LanguageEnum = require("./constants/LanguageEnum.js");
var _DmsFetch = require("./components/DmsFetch/DmsFetch.js");
var _pollux_dms = require("./pollux_dms");
var _DmsTokenHook = require("./components/DmsTokenHook/DmsTokenHook");
var _useDmsLogoffTabs = require("./Hooks/useDmsLogoffTabs.js");
var _log = require("./service/logging/log.js");
var _build_config = require("./service/config/build_config.js");
var _reactToastify = require("react-toastify");
var _reactRouterDom = require("react-router-dom");
var _client = require("react-dom/client");
var _DmsBatch = require("./pages/DmsBatch/DmsBatch");
var _DmsPageFingerPrinter = require("./pages/DmsFingerPrinter/DmsPageFingerPrinter.js");
var _DmsProductionOrder = require("./pages/DmsProductionOrder/DmsProductionOrder");
var _DmsLogin = require("./pages/DmsLogin/DmsLogin.js");
var _DmsPageUserLanguage = require("./pages/DmsUserLanguage/DmsPageUserLanguage");
var _DmsPageComponentImport = require("./pages/DmsComponentImport/DmsPageComponentImport.js");
var _DmsPageComponents = require("./pages/DmsComponent/DmsPageComponents.js");
var _DmsPageComponentTypeImport = require("./pages/DmsComponentTypeImport/DmsPageComponentTypeImport.js");
var _DmsPageFileImporter = require("./pages/DmsFileImporter/DmsPageFileImporter.js");
var _DmsPageFileType = require("./pages/DmsFileType/DmsPageFileType.js");
var _DmsPageLDAPAuthenticatorSettings = require("./pages/DmsAuthenticatorsSettings/DmsPageLDAPAuthenticatorSettings.js");
var _DmsPageLoginSettings = require("./pages/DmsLoginSettings/DmsPageLoginSettings.js");
var _DmsPageLogs = require("./pages/DmsLogs/DmsPageLogs.js");
var _DmsPageLogsReport = require("./pages/DmsLogsReport/DmsPageLogsReport.js");
var _DmsPageLogsSettings = require("./pages/DmsLogs/DmsPageLogsSettings.js");
var _DmsPageNotFound = require("./pages/DmsPageNotFound/DmsPageNotFound.js");
var _DmsAccessDenied = require("./pages/DmsAccessDenied/DmsAccessDenied.js");
var _DmsPagePartCompositionTable = require("./pages/DmsPartCompositionTable/DmsPagePartCompositionTable");
var _DmsPagePartTable = require("./pages/DmsPartTable/DmsPagePartTable");
var _DmsPageProduct = require("./pages/DmsProduct/DmsPageProduct.js");
var _DmsPageRemoteAuthenticatorSettings = require("./pages/DmsAuthenticatorsSettings/DmsPageRemoteAuthenticatorSettings.js");
var _DmsPageRole = require("./pages/DmsRole/DmsPageRole.js");
var _DmsPageRouteList = require("./pages/DmsRouteList/DmsPageRouteList.js");
var _DmsPageSystemSettings = require("./pages/DmsSettings/DmsPageSystemSettings.js");
var _DmsPageUser = require("./pages/DmsUser/DmsPageUser.js");
var _DmsPageUploadFileSettings = require("./pages/DmsUploadFile/DmsPageUploadFileSettings.js");
var _DmsUnderDevelopment = require("./pages/DmsUnderDevelopment/DmsUnderDevelopment.js");
var _DmsPageUSBComponents = require("./pages/DmsUSBComponent/DmsPageUSBComponents.js");
var _DmsPageProductImport = require("./pages/DmsProductImport/DmsPageProductImport");
var _DmsUploadFileSettings = require("./pages/DmsUploadFile/DmsUploadFileSettings.js");
var _DmsSystemSettings = require("./pages/DmsSystemSettings/DmsSystemSettings");
var _DmsSystemMonitor = require("./pages/DmsSystemMonitor/DmsSystemMonitor");
var _DmsPageRecipe = require("./pages/DmsRecipe/DmsPageRecipe.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// CSS Imports
// Font Imports
// Index Imports
// Theme Export
var _default = exports.default = _theme.default; // Context Export
// Admin Components
// Application Hooks
// Utilities
_DmsIntlManager.DmsIntlManager.init();
_notifications.Notifications.init();

// SSE: defer init to allow setBuildConfiguration to run first.
// If setBuildConfiguration is called (projects with build_config.js), it triggers SSE._connect() directly.
// If not called (projects without build_config.js), the fallback below uses the dummy config (enableSSE: true).
setTimeout(() => {
  if (!_sse.SSE._eventSource) {
    _sse.SSE.init();
  }
}, 0);

// Components

// Constants

// Functions and Utilities

// Wrap setBuildConfiguration to trigger SSE after config is set

const setBuildConfiguration = module => {
  (0, _build_config.setBuildConfiguration)(module);
  if (module.config.enableSSE) {
    _sse.SSE._connect();
  }
};

// Other Components

// Pages
exports.setBuildConfiguration = setBuildConfiguration;